// extracted by mini-css-extract-plugin
module.exports = {"div":"Addticket_div__2AhB9","p":"Addticket_p__9U81u","Card":"Addticket_Card__3SwkV","background":"Addticket_background__fUUEd","link":"Addticket_link__3phfw"};